import { Box, Chip, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';

const displayValue = (_key, value) => {
  if (Array.isArray(value)) return value.length ? value.join(', ') : 'Not Mentioned';
  return value || 'Not Mentioned';
};

export default function NipponInterviewSummary({ interviewData }) {
  if (!interviewData || (!Object.keys(interviewData.profile || {}).length && !interviewData.peers?.length && !Object.keys(interviewData.verification || {}).length)) return null;

  const verification = interviewData.verification || {};

  return (
    <Box sx={{ mb: 3, p: 2, border: '1px solid #eee', borderRadius: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Interview Extraction</Typography>

      <Typography variant="subtitle1" fontWeight={700}>Profile Data</Typography>
      <Table size="small" sx={{ mb: 2 }}>
        <TableBody>
          {Object.entries(interviewData.profile || {}).map(([key, item]) => (
            <TableRow key={key}>
              <TableCell sx={{ fontWeight: 600 }}>{key}</TableCell>
              <TableCell>{displayValue(key, item?.extractedValue ?? item)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Typography variant="subtitle1" fontWeight={700}>Peer References</Typography>
      {(interviewData.peers || []).length ? (
        <Table size="small" sx={{ mb: 2 }}>
          <TableBody>
            {interviewData.peers.map((peer, index) => (
              <TableRow key={index}>
                <TableCell>{peer.name || `Peer ${index + 1}`}</TableCell>
                <TableCell>{peer.currentCompany || 'Not Mentioned'}</TableCell>
                <TableCell>{peer.contactNumber || 'Not Mentioned'}</TableCell>
                <TableCell>{peer.performanceTrait || 'Not Mentioned'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : <Chip label="Not Mentioned" size="small" sx={{ mb: 2 }} />}

      {Object.keys(verification).length ? (
        <>
          <Typography variant="subtitle1" fontWeight={700}>Resume Verification</Typography>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1.5 }}>
            <Chip size="small" label={`Status: ${verification.overallStatus || 'N/A'}`} color={verification.mismatchedFields > 0 ? 'error' : 'success'} />
            <Chip size="small" label={`Matched: ${verification.matchedFields ?? 0}`} color="success" />
            <Chip size="small" label={`Mismatched: ${verification.mismatchedFields ?? 0}`} color="error" />
            <Chip size="small" label={`Missing: ${verification.missingFields ?? 0}`} />
          </Box>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell sx={{ fontWeight: 600 }}>Spoken Profile</TableCell>
                <TableCell>{displayValue('spokenProfile', verification.spokenProfile)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: 600 }}>Saved Candidate</TableCell>
                <TableCell>{displayValue('candidateProfile', verification.candidateProfile)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: 600 }}>Extracted Resume</TableCell>
                <TableCell>{displayValue('resumeProfile', verification.resumeProfile)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </>
      ) : null}
    </Box>
  );
}
